import { Pipe, PipeTransform } from '@angular/core';
import { EventInfoWithConsentResponse } from '@ent-regis/entregis-ts-angular/model/eventInfoWithConsentResponse';
import { shouldShowInstitutionalInvestorType } from 'src/app/functions/register-investor.function';

@Pipe({
  name: 'shouldShowInstitutionalInvestorType'
})
export class ShouldShowInstitutionalInvestorTypePipe implements PipeTransform {

  transform(eventInfoWithConsent: EventInfoWithConsentResponse | null | undefined): boolean {
    return shouldShowInstitutionalInvestorType(eventInfoWithConsent);
  }
}
